import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { IJob } from '../../interfaces/jobs';
import { IStaffType } from '../../interfaces/staff';
import { AuthProvider } from '../../providers/auth/auth';
import { JobsProvider } from '../../providers/jobs/jobs';

import { HomePage} from '../home/home';

@IonicPage()
@Component({
  selector: 'page-create-quote',
  templateUrl: 'create-quote.html'
})
export class CreateQuotePage implements OnInit {
  title = 'Quote';
  job: IJob;
  staffTypes: Array<IStaffType>;
  fbUser: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private jobsProvider: JobsProvider
  ) {
    this.job = this.navParams.get('job');
    console.log(this.job);
  }

  ngOnInit() {
    this.authProvider.getFbUser().then(fbUser => {
      this.fbUser = fbUser;
    });
  }

  acceptQuote() {
    this.job.createdBy = this.fbUser.uid;
    this.jobsProvider.createJob(this.job);

    this.navCtrl.setRoot(HomePage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CreateQuotePage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/create-quote/create-quote.ts